import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    titleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        position: "relative",
    },
    backButton: {
        position: "absolute !important" as any,
        top: "25%",
        left: "-30px",
    },
    formSubtitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    formTitle: {
        fontFamily: "Source Sans 3 !important",
        fontWeight: "600 !important",
        color: theme.palette.secondary.dark,
        fontSize: "32px !important",
        marginBottom: 32,
    },
    fieldsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
        justifyContent: "center",
        alignItems: "flex-start",
    },
    textField: {
        width: "100%",
        height: 56,
        textAlign: "left",
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    textFieldError: {
        width: "100%",
        height: 56,
        textAlign: "left",
        "& .MuiOutlinedInput-root": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Source Sans 3",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    submitButton: {
        "&.MuiButtonBase-root": {
            background: theme.palette.info.light,
            color: "white",
            height: "36px !important",
            fontFamily: "Source Sans 3",
            marginBottom: "30px",
            "&:hover": {
                background: theme.palette.info.light,
            },
        },
    },
    marginTop: {
        marginTop: "32px",
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        marginTop: "8px",
    },
}));
